<template>
  <div class="bird-game" :style="{ backgroundImage: 'url(' + bgUrl + ')' }">
    <img
      class="team-avatar team-avatar--bird"
      :class="{ 'is-shake': shakeBird }"
      :src="birdUrl"
      alt=""
      @animationend="shakeBird = false"
    />
    <img
      class="team-avatar team-avatar--pig"
      :class="{ 'is-shake': shakePig }"
      :src="pigUrl"
      alt=""
      @animationend="shakePig = false"
    />

    <div class="bird-game__bar-wrap">
      <div class="pk-bar">
        <div class="pk-bar__bird" :style="{ width: birdRatio + '%' }">
          <span class="pk-bar__score">{{ birdScore }}</span>
        </div>
        <div class="pk-bar__pig" :style="{ width: pigRatio + '%' }">
          <span class="pk-bar__score">{{ pigScore }}</span>
        </div>
        <img
          class="pk-marker"
          :src="pkUrl"
          alt=""
          :style="{ left: birdRatio + '%' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import bgUrl from '@/assets/birdGame/bg2.jpg'
import birdUrl from '@/assets/birdGame/bird.png'
import pigUrl from '@/assets/birdGame/pig.png'
import pkUrl from '@/assets/birdGame/pk.png'
import { loadBirdGameState, saveBirdGameState } from './cookie'

export default {
  name: 'BirdGame',
  data() {
    const saved = loadBirdGameState()
    return {
      bgUrl,
      birdUrl,
      pigUrl,
      pkUrl,
      birdScore: saved.bird,
      pigScore: saved.pig,
      shakeBird: false,
      shakePig: false,
      _saveTimer: null
    }
  },
  computed: {
    total() {
      return this.birdScore + this.pigScore
    },
    birdRatio() {
      if (this.total <= 0) return 50
      return Math.max(2, Math.min(98, (this.birdScore / this.total) * 100))
    },
    pigRatio() {
      return 100 - this.birdRatio
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown)
    document.body.classList.add('bird-game-lock-scroll')
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
    document.body.classList.remove('bird-game-lock-scroll')
    if (this._saveTimer) {
      clearTimeout(this._saveTimer)
      this.persist(true)
    }
  },
  methods: {
    persist(immediate) {
      const write = () => {
        saveBirdGameState({
          bird: this.birdScore,
          pig: this.pigScore,
          paused: false
        })
      }
      if (immediate) {
        if (this._saveTimer) {
          clearTimeout(this._saveTimer)
          this._saveTimer = null
        }
        write()
        return
      }
      if (this._saveTimer) return
      this._saveTimer = setTimeout(() => {
        this._saveTimer = null
        write()
      }, 120)
    },
    onKeydown(e) {
      if (!e || e.repeat) return
      const tag = (e.target && e.target.tagName) || ''
      if (tag === 'INPUT' || tag === 'TEXTAREA') return
      if (e.code === 'Space' || e.key === ' ') {
        e.preventDefault()
        this.addBird()
        return
      }
      if (e.code === 'Enter' || e.key === 'Enter') {
        e.preventDefault()
        this.addPig()
      }
    },
    addBird() {
      this.birdScore += 1
      this.triggerShake('bird')
      this.persist(false)
    },
    addPig() {
      this.pigScore += 1
      this.triggerShake('pig')
      this.persist(false)
    },
    triggerShake(side) {
      if (side === 'bird') {
        this.shakeBird = false
        this.$nextTick(() => {
          this.shakeBird = true
        })
        return
      }
      this.shakePig = false
      this.$nextTick(() => {
        this.shakePig = true
      })
    }
  }
}
</script>

<style lang="less">
@import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600&display=swap');

body.bird-game-lock-scroll {
  overflow: hidden;
}
</style>

<style lang="less" scoped>
.bird-game {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  background-color: #6ec8f5;
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.team-avatar {
  position: absolute;
  top: 29.5%;
  width: 15.6vw;
  height: 12.8vw;
  object-fit: contain;
  z-index: 4;
  pointer-events: none;
  /* 右下硬边投影，贴近截图 sticker 效果 */
  filter: drop-shadow(0.5vw 0.5vw 0 #048EA4);
}
.team-avatar--bird {
  left: 26%;
}
.team-avatar--pig {
  right: 26%;
}
.team-avatar.is-shake {
  animation: bird-avatar-shake 0.35s ease-in-out;
}

@keyframes bird-avatar-shake {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
  20% {
    transform: translate(-4px, 2px) rotate(-6deg);
  }
  40% {
    transform: translate(5px, -2px) rotate(6deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(-4deg);
  }
  80% {
    transform: translate(3px, -1px) rotate(3deg);
  }
}

.bird-game__bar-wrap {
  position: absolute;
  left: 50%;
  top: 60.5%;
  transform: translateX(-50%);
  width: min(830px, 83vw);
  z-index: 6;
}

.pk-bar {
  position: relative;
  display: flex;
  height: 20px;
  border-radius: 999px;
  overflow: visible;
  border: 1px solid #2b2118;
  background: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.58);
}

.pk-bar__bird,
.pk-bar__pig {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  transition: width 0.12s ease-out;
  overflow: hidden;
}
.pk-bar__bird {
  justify-content: flex-start;
  padding-left: 14px;
  background: #FB2203;
  border-radius: 999px 0 0 999px;
}
.pk-bar__pig {
  justify-content: flex-end;
  padding-right: 14px;
  background: #00C935;
  border-radius: 0 999px 999px 0;
}
.pk-bar__score {
  color: #fff;
  font-family: 'Fredoka', 'Comic Sans MS', 'Chalkboard SE', 'Segoe Print', cursive;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 1;
  text-shadow: none;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.pk-marker {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 55px;
  height: auto;
  object-fit: contain;
  pointer-events: none;
  transition: left 0.12s ease-out;
}

@media (max-width: 900px) {
  .team-avatar--bird {
    left: 18%;
  }
  .team-avatar--pig {
    right: 18%;
  }
  .pk-bar {
    height: 20px;
  }
  .pk-bar__score {
    font-size: 13px;
    font-weight: 500;
  }
}
</style>
